<template>
  <div class="black-inputs" v-loading="loadingPayement">
    <el-row class="texts" v-if="!payementDone && !payementFail && getSelectedResa">
      <el-col v-if="getSelectedResa && getSelectedResa.type === 'caution'" :span="22" :offset="1">
        Vous allez prélever la caution à<br>
        {{ getClientfullName }}<br>
        d'un montant de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
          Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
        en êtes-vous bien sûr ?<br>
      </el-col>
      <el-col v-else :span="22" :offset="1">
        En validant la réservation, vous allez procéder au prépaiement pour<br>
        {{ getClientfullName }}<br>
        d'un montant de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
          Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
        en êtes-vous bien sûr ?<br>
      </el-col>
    </el-row>
    <el-row class="texts" v-if="payementDone && !payementFail && getSelectedResa">
      <el-col v-if="getSelectedResa && getSelectedResa.type === 'caution'" :span="22" :offset="1">
        La caution de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
          Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
        de {{ getClientfullName }}<br>
        a été encaissé.<br>
      </el-col>
      <el-col v-else :span="22" :offset="1">
        Le prépaiement de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
          Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€<br>
        de {{ getClientfullName }}<br>
        a été encaissé. <br>
      </el-col>
    </el-row>

    <el-row class="texts" v-if="payementFail && getSelectedResa">
      <el-col v-if="getSelectedResa && getSelectedResa.type === 'caution'" :span="22" :offset="1">
        Le prélèvement de la caution a échoué pour<br>
        {{ getClientfullName }}<br>
        d'un montant de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
          Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€
      </el-col>
      <el-col v-else :span="22" :offset="1">
        L'encaissement du prépaiement de <span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span
          v-else>{{ Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€ a
        échoué.<br>
        La réservation n'a pas pu être validée correctement.<br>
        Merci de vous rapprocher du client pour voir comment vous allez valider sa réservation :<br>
        {{ getClientfullName }}<br>
        <a :href="'tel:' + this.getClientByid(this.getSelectedResa.cid).tel">{{
          this.getClientByid(this.getSelectedResa.cid).tel }}</a><br>
        <a :href="'mailto:' + this.getClientByid(this.getSelectedResa.cid).email">{{
          this.getClientByid(this.getSelectedResa.cid).email }}</a><br>
        P:<span v-if="getSelectedResa.total">{{ getSelectedResa.total }}</span><span v-else>{{
          Math.round((getSelectedResa.amount * getSelectedResa.nbCouvert) * 100) / 100 }}</span>€
      </el-col>
    </el-row>

    <el-row class="btns">
      <el-col :span="10" :offset="1" v-if="!payementDone && !payementFail">
        <el-button class="dark" type="primary" @click="closeDialog(true)">Annuler</el-button>
      </el-col>
      <el-col :span="10" :offset="1" v-if="!payementDone && !payementFail">
        <el-button type="primary" @click="procedPayement()">Valider</el-button>
      </el-col>
      <el-col :span="10" :offset="7" v-if="payementDone || payementFail">
        <el-button type="primary" @click="closeDialog()">Ok</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import * as resaState from '../../store/types/resa-state'
import { ERequestType, fetchGetHelper, fetchPutHelper } from '../../tools/fetch'
import { fetchCustomerInfos, fetchPayementIntent, fetchRetriveSI } from '../../tools/fetchHelper'
import { sendResaEchecPaiement, sendResaEchecPaiementRestaurateur } from '../../tools/messageSender'
import { formatTimeH, parseTime } from '../../tools/timeTool'

export default {
  name: 'ResaPayement',
  data() {
    return {
      loadingPayement: false,
      payementDone: false,
      payementFail: false
    }
  },
  computed: {
    ...mapGetters({
      getClientByid: 'newClients/getClientByid',
      getSelectedResa: 'newReservations/getSelectedResa',
      getCurrentTimestamp: 'calendar/getCurrentTimestamp',
      getSelectedSubService: 'newServices/getSelectedSubService',
      getAllInfos: 'infos/getAllInfos'
    }),
    getClientfullName() {
      if (this.getSelectedResa) {
        let currentClient = this.getClientByid(this.getSelectedResa.cid)
        return `${currentClient.civ} ${currentClient.name} ${currentClient.prenom}`
      }
    }
  },
  methods: {
    ...mapActions({
      updateClientCount: 'newClients/updateClientCount',
      updateStateResa: 'newReservations/updateStateResa',
      updatePayementInfoDone: 'newReservations/updatePayementInfoDone',
      acceptResa: 'newReservations/acceptResa',
      unSelectedTables: 'newRooms/unSelectedTables'
    }),
    ...mapMutations({
      setDialogPayement: 'displayer/setDialogPayement'
    }),
    closeDialog: function (aborded = false) {
      if (this.getSelectedResa && this.getSelectedResa.type === 'caution' && aborded) {
        let tmpState = resaState.CONFIRMED

        let updateR = Object.assign({}, this.getSelectedResa)

        updateR.modifyBy = 'RESTAURANT'
        if (this.$router.currentRoute.name === 'PRedirect') updateR.modifyBy = 'PERMANENCE'
        this.updateStateResa({ data: updateR, state: tmpState, ts: this.getCurrentTimestamp, service: this.getSelectedSubService })
      }
      this.setDialogPayement(false)
      this.unSelectedTables()
    },
    async procedPayement() {
      let currentResa = this.getSelectedResa
      let currentClient = this.getClientByid(this.getSelectedResa.cid)
      this.loadingPayement = true
      // get stripe setup intent
      await fetchRetriveSI(currentResa.sid).then(async (res) => {
        // get customer
        await fetchCustomerInfos(res.customer).then(async (resC) => {
          // if setup intent was succeeded
          if (res.status === 'succeeded') {
            // initiate Payement intent
            await fetchPayementIntent(
              res.payment_method,
              currentResa.amount * currentResa.nbCouvert,
              res.customer,
              resC.email,
              `${this.getAllInfos.restoName} - ${currentClient.civ} ${currentClient.name} ${currentClient.prenom} - tel : ${currentClient.tel} - email : ${currentClient.email} - service : ${this.getSelectedResa.ms} - le : ${this.getSelectedResa.dateResa.labelDay} ${this.getSelectedResa.dateResa.label} ${this.getSelectedResa.dateResa.labelMonth} ${this.getSelectedResa.dateResa.year} à ${this.getSelectedResa.hour}`
            ).then(async (resPI) => {
              await fetchGetHelper(ERequestType.CASHRESAS.GET_BY_SID, `stripeid=${this.getSelectedResa.stripeid}`).then(async (cashResa) => {
                // update paiement intent id
                let newCashResa = cashResa.data
                newCashResa.paidid = resPI.id
                await fetchPutHelper(ERequestType.CASHRESAS.UPDATE, newCashResa).then(async (updatedCR) => {
                  this.loadingPayement = false
                  this.payementDone = true
                  if (currentResa && currentResa.type === 'caution') {
                    // update count noshow
                    // update state resa
                    /* this.acceptResa({
                      resa: currentResa
                    }) */
                  } else { // prépaiement
                    await this.acceptResa({
                      resa: currentResa
                    })
                  }

                  let resaTmp = Object.assign({}, this.getSelectedResa)
                  resaTmp.modifyBy = 'RESTAURANT'
                  if (this.$router.currentRoute.name === 'PRedirect') resaTmp.modifyBy = 'PERMANENCE'

                  // update payement status
                  this.updatePayementInfoDone({ data: resaTmp, ts: this.getCurrentTimestamp, service: this.getSelectedSubService, payementDone: this.payementDone })
                })
              })
            }).catch((error) => {
              // The document probably doesn't exist.
              console.error('Payement error - Update info payement to payement Fail')
              console.error(error)
              this.loadingPayement = false
              this.payementDone = false
              this.payementFail = true
              if (this.getSelectedResa.payementDone === undefined) {
                let hourFormatted = formatTimeH(parseTime(this.getSelectedResa.hour))
                // send mail to resto
                sendResaEchecPaiementRestaurateur({
                  clientName: `${currentClient.name} ${currentClient.prenom}`,
                  clientEmail: currentClient.email,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${this.getSelectedResa.dateResa.labelDay} ${this.getSelectedResa.dateResa.day.toString()} ${this.getSelectedResa.dateResa.labelMonth} ${this.getSelectedResa.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: '',
                  nbCouverts: this.getSelectedResa.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  source: this.getSelectedResa.source
                })
                // send mail to client
                sendResaEchecPaiement({
                  clientName: `${currentClient.civ} ${currentClient.name} ${currentClient.prenom}`,
                  clientEmail: currentClient.email,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${this.getSelectedResa.dateResa.labelDay} ${this.getSelectedResa.dateResa.day.toString()} ${this.getSelectedResa.dateResa.labelMonth} ${this.getSelectedResa.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: '',
                  nbCouverts: this.getSelectedResa.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  url: '',
                  type: this.getSelectedResa.type
                })
              }

              let resaTmp = Object.assign({}, this.getSelectedResa)
              resaTmp.modifyBy = 'RESTAURANT'
              if (this.$router.currentRoute.name === 'PRedirect') resaTmp.modifyBy = 'PERMANENCE'

              this.updatePayementInfoDone({ data: resaTmp, ts: this.getCurrentTimestamp, service: this.getSelectedSubService, payementDone: this.payementDone })
            })
          }
        })
      })
    }
  },
  watch: {
    'getSelectedResa': function (val, oldVal) {
      if (val && val.payementDone) this.payementDone = true
      if (val && oldVal && val.id === oldVal.id) {
        return ''
      }
      this.loadingPayement = false
      this.payementDone = false
      if (val && val.payementDone) this.payementDone = true
      this.payementFail = false
    }
  },
  created: function () { }
}
</script>

<style lang="scss">
.btns {
  margin-top: 20px;
}

.texts {
  text-align: center;
}
</style>
